import { Component } from '@angular/core';
import { PORTALS } from './core/portals';
import { PortalCard } from './portal-card/portal-card';

@Component({
  selector: 'app-root',
  imports: [PortalCard],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App {
  protected readonly portals = PORTALS;
}
